import React from 'react';
import Link from 'next/link';
import * as models from 'src/models';
import { GetProps } from 'src/types/Utility';
import * as localization from 'src/localization';
import useLocalized from 'src/hooks/useLocalized';
import Text from 'src/components/Text';
import Anchor from 'src/components/Anchor';
import UnorderedList from 'src/components/UnorderedList';

export type Props = Omit<GetProps<typeof UnorderedList>, 'children'> & {
  institution: models.institution.types.Institution;
  institutionSeed: models.institutionSeed.types.InstitutionSeed;
};

const InstitutionRelatedArticles: React.FC<Props> = ({ institution, institutionSeed, ...rest }) => {
  const localized = useLocalized(localization.components.InstitutionRelatedArticles.localized);

  return (
    <UnorderedList {...rest}>
      <UnorderedList.Item>
        {/* Only available in Japanese */}
        <Link href={`/${institutionSeed.system}/${institution.entityKey}`} locale="ja" passHref>
          <Anchor>
            <Text variant="body">{localized.connectionGuide}</Text>
          </Anchor>
        </Link>
      </UnorderedList.Item>
    </UnorderedList>
  );
};

export default InstitutionRelatedArticles;
